goog.provide('el8.apphome.reqAct.fetchFn');

goog.require('el8.apphome.reqAct.reqActPatients');
goog.require('el8.model.identify');
goog.require('el8.practicedata.rxRefillRequests');
goog.require('el8.practicedata.unassignedEmails');
goog.require('el8.ptdata.base');
goog.require('el8.ptdata.documentReminderNotifications');
goog.require('el8.ptdata.letterReceipts');
goog.require('el8.ptdata.letters');
goog.require('el8.ptdata.nonvisitNotes');
goog.require('el8.ptdata.plrCollaboratorNotifications');
goog.require('el8.ptdata.unreadLetterNotifications');
goog.require('el8.ptdata.directMessages');
goog.require('el8.ptdata.reports');

el8.apphome.reqAct.fetchFn = function(arg, force) {

    var fetchArgs = arg;
    var returnSingle = false;

    // Support a single id as argument
    if (!(arg instanceof Array)) {
        returnSingle = true;
        fetchArgs = [arg];
    }

    var _getEntitySet = function(mClass) {
        if (mClass === 'ReqActPatient' || mClass === 'Patient') {
            return el8.apphome.reqAct.reqActPatients;
        } else if (mClass === 'RxRefillRequest') {
            return el8.practicedata.rxRefillRequests;
        } else if (mClass === 'MessageThread') {
            return el8.ptdata.messageThreads;
        } else if (mClass === 'IncomingEmail') {
            return el8.practicedata.unassignedEmails;
        } else if (mClass === 'Letter') {
            return el8.ptdata.letters;
        } else if (mClass === 'IncomingDirectMessage') {
            return el8.ptdata.directMessages;
        } else if (mClass === 'NonvisitNote') {
            return el8.ptdata.nonvisitNotes;
        } else if (mClass === 'LetterReceipt') {
            return el8.ptdata.letterReceipts;
        } else if (mClass === 'UnreadLetterNotification') {
            return el8.ptdata.unreadLetterNotifications;
        } else if (mClass === 'PatientCollaboratorNotification') {
            return el8.ptdata.plrCollaboratorNotifications;
        } else if (mClass === 'Report') {
            return el8.ptdata.reports;
        } else if (mClass === 'DocumentReminderNotification') {
            return el8.ptdata.documentReminderNotifications;
        }
    };

    /**
     * Store the data var that comes in the arg for ReqActPatient's
     */
    var idToDataCache = {};
    var idsToAdd = [];
    fetchArgs.map(function(a) {
        if (a['data']) {
            idToDataCache[a['id']] = a['data'];
            for (var i=0; i<a['data'].length; i++) {
                var mClass = el8.model.idToModelClass(a['data'][i]['id']);
                var RENDERABLE_CLASSES = ['MessageThread', 'Letter', 'LetterReceipt',
                                          'UnreadLetterNotification', 'IncomingDirectMessage',
                                          'PatientCollaboratorNotification', 'Report',
                                          'DocumentReminderNotification'];
                if (_.contains(RENDERABLE_CLASSES, mClass)) {
                    idsToAdd.push(a['data'][i]['id']);
                } else if(mClass === 'NonvisitNote') {
                    // checking to see if it's a NonvisitNote AND it's got type DIRECT
                    if (a['data'][i]['nonvisitnote_type'] === 'DIRECT') {
                        idsToAdd.push(a['data'][i]['id']);
                    }
                }
            }
        }
    });

    var results = [];
    var needFetch = [];
    if (force === true) {
        needFetch = fetchArgs.map(function(a) { return a['id']; });
        // Set all elements of 'results' to null
        results = fetchArgs.map(function(a) { return null; });
    } else {
        var r = null;
        fetchArgs.map(function(a) {
            r = null;
            var entitySet = _getEntitySet(el8.model.idToModelClass(a['id']));
            if (entitySet) { r = entitySet.getById(a['id'], true); }
            results.push(r);
            if (!r) { needFetch.push(a['id']); }
        });
    }
    // At this point, 'results' should be the same length as
    // 'ids' and contain only objects we want to return (null otherwise).
    // Meanwhile, 'needFetch' contains all the ids we need to fetch
    if (needFetch.length || idsToAdd.length) {
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.post('reqActItems'),
            async: false,
            data: { id: needFetch.concat(idsToAdd) },
            dataType: "json",
            success: function(data) {
                // We assume the results come back in the same
                // order as we sent up the id's
                var fetched = data;
                if (fetched.length !== (needFetch.length + idsToAdd.length)) {
                    el8.uiwidget.alert('Sorry, there was an error fetching one of '+
                        'the documents you requested');
                }
                for(var i=0; i<results.length; i++) {
                    if (!results[i]) {
                        var obj = fetched.shift();
                        var entitySet = _getEntitySet(el8.model.idToModelClass(obj['id']));
                        results[i] = entitySet.create(obj, true); // should NOT notify
                    }
                }
                // These are the remaining messageIds, if any. Just add to cache
                for (var i=0; fetched.length; i++) {
                    var obj = fetched.shift();
                    var entitySet = _getEntitySet(el8.model.idToModelClass(obj['id']));
                    entitySet.create(obj, true); // should NOT notify
                }
            }
        });
    }

    /**
     * Populate data field
     */
    for (var i=0; i<results.length; i++) {
        if (results[i] && results[i].setData) {
            if (idToDataCache[results[i].getId()]) {
                results[i].setData(idToDataCache[results[i].getId()]);
            } else {
                results[i].setData(null);
            }
        }
    }

    return returnSingle ? results[0] : results;
};

